import {
  KEY_SHOPPING_CART,
  KEY_VERIFY_ORDER,
  PAYMENT_METHOD_MOMO,
  PAYMENT_METHOD_PAYOO_LIST,
  PAYMENT_METHOD_SC,
  PAYMENT_METHOD_VNPAY,
  VERIFY_OTP_ERROR_CODES,
} from "../common/constant";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import {
  IShoppingCart,
  IShoppingCartGiftItem,
  IShoppingCartItem,
} from "../models/IShoppingCartModel";
import { order, payments } from "../repositories/";
import { EPromotionType } from "../models/IPromotionModel";
import IPromotionVoucherCodeModel from "../models/IPromotionVocherCodeModel";
import IReferralCodeModel from "../models/IReferralCodeModel";
import IShippingInfo from "../models/shippingInfoModel";
import { IOrder } from "../models/submitOrderModel";
import { checkInventory } from "./products";
import IInvoiceInfoModel from "../models/IInvoiceInfoModel";
import * as GTM from "../components/tracking/GTM";
import { IOTPInfo } from "../screens/Checkout/verifyOTPModal";
import { setVoucherInfo } from "../utils/helpers";

const addCartItem = (item: IShoppingCartItem) => {
  const data = localStorage.getItem(KEY_SHOPPING_CART);
  let shoppingCart: IShoppingCart = data ? JSON.parse(data) : null;
  if (!data) {
    shoppingCart = {
      _id: uuidv4(),
      items: [],
      total_quantity: 0,
    };
  }

  if (!shoppingCart.items) {
    shoppingCart.items = [];
  }

  shoppingCart.items.push(item);

  localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(shoppingCart));

  return shoppingCart;
};

const getShoppingCart = () => {
  const data = localStorage.getItem(KEY_SHOPPING_CART) || "{}";
  let shoppingCart: IShoppingCart = JSON.parse(data);

  if (!shoppingCart || Object.keys(shoppingCart).length === 0) {
    return {
      _id: uuidv4(),
      items: [],
      total_quantity: 0,
    };
  }

  return shoppingCart;
};

export const updateShoppingCartItems = async (
  scItem?: IShoppingCartItem,
  deleteItem?: string
) => {
  /*
      scItem: item update or create,
      deleteItem: item delete
    */

  let cart = getShoppingCart() || {};
  if (cart) {
    let shoppingCartItems = cart.items ? cart.items : [];
    if (scItem) {
      // tìm trong shopping Cart nếu không có sp update thì sp đó thêm mới
      let sciIndex = shoppingCartItems.findIndex((x) => x._id === scItem._id);

      if (sciIndex !== -1) {
        shoppingCartItems[sciIndex] = scItem;
      } else {
        shoppingCartItems.push(scItem);
      }
    }
    if (deleteItem) {
      _.remove(shoppingCartItems, (x) => x._id == deleteItem);
    }
    cart.items = shoppingCartItems;
  }
  return await getPromotionOrders(cart);
};

export const refreshShoppingCart = async () => {
  let cart = getShoppingCart();

  if (!cart) return null;

  return await getPromotionOrders(cart);
};

export const getPromotionOrders = async (cart: IShoppingCart) => {
  let shoppingCartItems = cart.items ? cart.items : [];
  // let quantity_gift = 0;
  // let order_gift = 0;
  // let quantity = 0;
  if (!cart || !cart.items || !cart.items.length) {
    cart.number_total_amount = 0;
    cart.order_discount_amount = 0;
    cart.sub_total_amount = "0";
    cart.total_amount = "0";
    cart.total_amount_discount = "";
    cart.total_quantity = 0;
    localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
    return cart;
  }

  if (cart) {
    const products = shoppingCartItems.map(function (c) {
      const product_specs = _.values(c.product_property)
        .filter((c) => !c.is_use)
        .map((c) => c.value)
        .join("|");

      const product_gifts = c.gift_promotions
        ?.filter((p) => p.default_prop)
        .map((c) => {
          return _.pick(c, ["default_prop", "feature_id"]);
        });

      return {
        product_feature_code: c.product.code,
        product_specs, // value of specs
        quantity: c.quantity,
        random_code: c._id,
        product_gifts,
      };
    });
    const info = {
      products,
      order_voucher_code: cart?.order_voucher?.code,
    };

    const result = await order.getOrderPromotion(info);

    if (result && result.status === 200 && result.data) {
      const _products = result.data.find(
        (x) => x.type == EPromotionType.PRODUCT
      );
      if (_products && cart.items) {
        for (let i = 0; i < cart.items.length; i++) {
          let item = cart.items[i];
          const sci = _products?.products?.find(
            (x) => x.random_code == item._id
          );
          if (sci) {
            item.sealed_price = sci.price;
            item.amount = sci.discounted_price;
            item.sub_total_amount = sci.sub_total_amount;
            item.discount_percent = sci.discount_percent;
            item.gift_promotions = sci.gift_promotions?.map((x) => {
              let gift: IShoppingCartGiftItem = {
                _id: uuidv4(),
                quantity: x.quantity,
                sealed_price: x.price,
                default_prop: x.default_prop,
                feature_id: x.feature_id,
                product: {
                  code: x.code + "",
                  name: x.name + "",
                  img: x.img ? x.img : "",
                  _id: x.feature_id + "",
                },
                product_name_extra: x.note,
                options: x.options,
              };
              return gift;
            });
          }
        }
      }
      const orderSummary = result.data.find(
        (x) => x.type == EPromotionType.ORDER_SUMARY
      );
      cart.total_quantity = orderSummary?.sumary?.quantity;
      cart.sub_total_amount = orderSummary?.sumary?.original_total_price;
      cart.total_amount_discount =
        orderSummary?.sumary?.discount_voucher_amount;
      cart.total_amount = orderSummary?.sumary?.total_price;
      cart.number_total_amount = orderSummary?.sumary?.order_total_amount;
      cart.order_discount_amount = orderSummary?.sumary?.order_discount_amount;

      const _orderSummary = result.data.find(
        (x) => x.type == EPromotionType.ORDER_SUMARY
      );

      if (cart?.order_voucher?.code) {
        if (
          !_orderSummary ||
          !_orderSummary.sumary ||
          !_orderSummary.sumary.discount_voucher_code
        ) {
          cart.order_voucher.code = "";
          cart.order_voucher.name = "";
        } else if (
          _orderSummary.sumary.discount_voucher_code != cart.order_voucher.code
        ) {
          cart.order_voucher.code = _orderSummary.sumary.discount_voucher_code;
          cart.order_voucher.name =
            _orderSummary.sumary.discount_voucher_name || "";
        }
      }

      localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
    }
  }
  return cart;
};

export const checkVoucherCode = async (code: string) => {
  const rs = await order.checkVoucherCode(code);
  return rs;
};

export const checkReferralCode = async (code: string) => {
  const rs = await order.checkReferralCode(code);
  return rs;
};

export const updateReferralCode = (referral_code?: IReferralCodeModel) => {
  let cart = getShoppingCart() || {};
  if (cart) {
    if (referral_code && referral_code.code) {
      referral_code.code = referral_code.code.toUpperCase();
    }
    cart.referral_code = referral_code;
    localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
  }
};

export const updateShippingInfo = (shippingInfo?: IShippingInfo | null) => {
  let cart = getShoppingCart() || {};
  if (cart) {
    if (shippingInfo) {
      delete shippingInfo.authen_id;
      delete shippingInfo.created_at;
      delete shippingInfo.updated_at;
      delete shippingInfo.is_active;

      cart.shipping_info = shippingInfo;
      localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
    }
  }
};

export const updatePaymentMethod = (paymentMethod?: any) => {
  let cart = getShoppingCart() || {};
  if (cart) {
    if (paymentMethod) {
      cart.payment_method = paymentMethod;
      localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
    }
  }
};

export const updateCaptchaToken = (token?: any) => {
  let cart = getShoppingCart() || {};
  if (cart) {
    if (token) {
      cart.token = token;
      localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
    }
  }
};

export const updateInvoiceInfo = (invoiceInfo?: IInvoiceInfoModel) => {
  let cart = getShoppingCart() || {};
  if (cart && invoiceInfo) {
    cart.invoice_info = invoiceInfo;
    localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
  }
};

export const updateVoucherCode = async (
  order_voucher?: IPromotionVoucherCodeModel
) => {
  let cart = getShoppingCart() || {};
  if (cart) {
    if (order_voucher && order_voucher.code) {
      order_voucher.code = order_voucher.code.toUpperCase();
    }
    cart.order_voucher = order_voucher;
    localStorage.setItem(KEY_SHOPPING_CART, JSON.stringify(cart));
    setVoucherInfo({
      code: order_voucher?.code || "",
      name: order_voucher?.name || "",
    });
  }
  return await getPromotionOrders(cart);
};

export const getVerifyOTPInfo = (phoneNumber: string = "") => {
  const otpInfo: string | null = localStorage.getItem(
    `${KEY_VERIFY_ORDER}${phoneNumber}`
  );

  return otpInfo ? JSON.parse(otpInfo || "") : null;
};

export const updateOTPInfo = (otpInfo?: IOTPInfo) => {
  let cart = getShoppingCart() || {};

  const verifyOTPInfo = getVerifyOTPInfo(cart?.shipping_info?.phone_number);

  if (cart && otpInfo) {
    localStorage.setItem(
      `${KEY_VERIFY_ORDER}${cart.shipping_info?.phone_number}`,
      JSON.stringify({ ...verifyOTPInfo, ...otpInfo })
    );
  }
};

export const clearShoppingCart = () => {
  let cart = getShoppingCart() || {};
  if (cart?.shipping_info?.phone_number) {
    localStorage.removeItem(
      `${KEY_VERIFY_ORDER}${cart.shipping_info.phone_number}`
    );
  }

  localStorage.setItem(KEY_SHOPPING_CART, "");
};

export const validateCart = async () => {
  let result = {
    isValid: false,
    messageCode: "",
    message: "",
  };

  let cart = getShoppingCart() || {};

  if (!cart || !cart.items || cart.items.length == 0) {
    result.isValid = true;
    result.messageCode = "shopping_cart_empty";
    return result;
  }

  if (!cart.payment_method) {
    result.isValid = true;
    result.messageCode = "shopping_cart_payment_method_empty";
    return result;
  }

  if (!cart.shipping_info) {
    result.isValid = true;
    result.messageCode = "shopping_cart_shipping_info_empty";
    return result;
  }

  if (!cart.shipping_info?.address?.full_address) {
    result.isValid = true;
    result.messageCode = "customer_address_valid";
    return result;
  }

  if (!cart.shipping_info?.address?.province?.id) {
    result.isValid = true;
    result.messageCode = "customer_province_id_valid";
    return result;
  }

  if (!cart.shipping_info?.address?.district?.id) {
    result.isValid = true;
    result.messageCode = "customer_district_id_valid";
    return result;
  }

  if (!cart.shipping_info?.address?.ward?.id) {
    result.isValid = true;
    result.messageCode = "customer_ward_id_valid";
    return result;
  }

  if (!cart.shipping_info?.full_name_recevied) {
    result.isValid = true;
    result.messageCode = "full_name_recevied_valid";
    return result;
  }

  // if (!cart.shipping_info?.first_name) {
  //   result.isValid = true;
  //   result.messageCode = "customer_first_name_valid";
  //   return result;
  // }

  // if (!cart.shipping_info?.last_name) {
  //   result.isValid = true;
  //   result.messageCode = "customer_last_name_valid";
  //   return result;
  // }

  if (!cart.shipping_info?.phone_number) {
    result.isValid = true;
    result.messageCode = "customer_phone_number_is_empty";
    return result;
  }

  let pfs = cart.items.map((p) => {
    const product_specs = _.values(p.product_property)
      .filter((c) => !c.is_use)
      .map((c) => c.value)
      .join("|");
    return {
      feature_id: p.product.feature?.feature_id,
      product_specs: product_specs,
    };
  });

  const inventory = await checkInventory(pfs);
  if (!inventory.in_stock) {
    result.isValid = true;
    result.messageCode = "product_out_of_stock";
    result.message = inventory.message;
    return result;
  }
  return result;
};

export const checkInventoryProductAddToCart = async (product: any) => {
  let result = {
    isValid: false,
    messageCode: "",
    message: "",
  };

  const product_specs = _.values(product.product_property)
    .filter((c) => !c.is_use)
    .map((c) => c.value)
    .join("|");

  const pfs = [
    {
      feature_id: product.product.feature?.feature_id,
      product_specs: product_specs,
    },
  ];

  const inventory = await checkInventory(pfs);

  if (!inventory.in_stock) {
    result.isValid = true;
    result.messageCode = "product_out_of_stock";
    result.message = inventory.message;
    return result;
  }
  return result;
};

const trackingGTM = (cart: IShoppingCart, kde_order_id: string) => {
  if (!cart || !cart.items) {
    return;
  }

  let dataTracking: GTM.IOrderTracking = {
    orderInfo: {
      order_id: kde_order_id,
      total: 0,
      voucher_code: "",
      phone_number: cart.shipping_info?.phone_number || "",
    },
    products: [],
  };
  if (cart && cart.items) {
    dataTracking.orderInfo.total = cart.total_amount
      ? parseInt(cart.total_amount.replaceAll(".", ""))
      : 0;
    dataTracking.orderInfo.voucher_code = cart.order_voucher_code
      ? cart.order_voucher_code
      : "";
    dataTracking.products = cart.items.map((sci) => {
      let unit_price = sci.product?.feature?.price_promotion
        ? parseInt(sci.product?.feature?.price_promotion?.replaceAll(".", ""))
        : 0;
      let product: GTM.IProductTrackingInfo = {
        name: sci.product.name,
        id: sci.product.code,
        price: sci.product?.feature?.price
          ? parseInt(sci.product?.feature?.price?.replaceAll(".", ""))
          : 0,
        category: sci.product?.category_name,
        variant: sci.product?.feature?.spec,
        quantity: sci.quantity,
        promotion: "",
        discount_price: sci.product?.feature?.price_save
          ? parseInt(sci.product?.feature?.price_save.replaceAll(".", ""))
          : 0,
        unit_price: unit_price,
        subtotal_amount: unit_price * sci.quantity,
      };
      return product;
    });
  }
  GTM.purchasesOrder(dataTracking.orderInfo, dataTracking.products);
};

export const submitOrder = async (cb: Function) => {
  let cart = getShoppingCart() || {};

  if (cart) {
    // TODO validate cart
    // TODO check inventory
    // TODO get lat long

    let verifyOTPInfo = getVerifyOTPInfo(cart.shipping_info?.phone_number);

    let _order: IOrder = {
      ship_info: {
        district: cart.shipping_info?.address?.district?.id
          ? cart.shipping_info?.address?.district?.id
          : 0,
        ward: cart.shipping_info?.address?.ward?.id
          ? cart.shipping_info?.address?.ward?.id
          : 0,
        province: cart.shipping_info?.address?.province?.id
          ? cart.shipping_info?.address?.province?.id
          : 0,
        full_address: cart.shipping_info?.address?.full_address + "",
        lat: 0,
        lng: 0,
        // full_name: `${cart.shipping_info?.first_name} ${cart.shipping_info?.last_name}`,
        full_name: cart.shipping_info?.full_name_recevied || "",
        phone_number: cart.shipping_info?.phone_number + "",
        note: cart.shipping_info?.note + "",
        email: cart.shipping_info?.email || "",
      },
      order_voucher_code: (cart.order_voucher && cart.order_voucher.code) || "",
      payment_method: cart.payment_method?.payment_method,
      order_summary: {
        original_total_price: cart.sub_total_amount + "",
        quantity: cart.total_quantity ? cart.total_quantity : 0,
        total_amount: cart.number_total_amount ? cart.number_total_amount : 0,
        order_discount_amount: cart.order_discount_amount
          ? cart.order_discount_amount
          : 0,
        total_price: cart.total_amount + "",
      },
      products: cart.items?.map((x) => {
        let product_specs = _.values(x.product_property)
          .filter((c) => !c.is_use)
          .map((c) => c.value)
          .join("|");

        const gift_promotions = x?.gift_promotions
          ?.filter((p) => p.default_prop)
          .map((c) => {
            return _.pick(c, ["default_prop", "feature_id"]);
          });
        return {
          product_feature_code: x.product.code,
          product_property: x.product_property,
          product_specs: product_specs,
          quantity: x.quantity,
          random_code: x._id + "",
          product_gifts: gift_promotions,
        };
      }),
      invoice_info: cart.invoice_info,
      info_anonymous: {
        anonymous_fullname: cart.shipping_info?.full_name_recevied || "",
        anonymous_phone: cart.shipping_info?.phone_number + "",
      },
      otp_verify: verifyOTPInfo,
      otp_method: verifyOTPInfo?.otp_method,
      token: cart.token,
    };

    try {
      const rs = await order.submitOrder(_order);
      if (rs.data && rs.data.code && VERIFY_OTP_ERROR_CODES[rs.data.code]) {
        cb(rs.data);
      } else if (rs.status == 200 && rs.data) {
        if (rs.data?.is_processing_verify) {
          cb(rs.data);
          return;
        }
        trackingGTM(cart, rs.data.order_id);
        if (cart.number_total_amount) {
          rs.data.total_price = cart.total_amount;
        }

        if (
          cart.payment_method?.payment_method === PAYMENT_METHOD_MOMO ||
          cart.payment_method?.payment_method === PAYMENT_METHOD_VNPAY
        ) {
          const params = {
            order_id: rs.data.id,
            kde_order_id: rs.data.order_id,
          };
          const result: any =
            await payments.signAndEncryptPaymentRequest(params);

          if (result.status == 200) {
            clearShoppingCart();
            result.data.payment_method = PAYMENT_METHOD_SC;
            cb(result.data);
          }
        } else if (
          PAYMENT_METHOD_PAYOO_LIST.indexOf(
            cart.payment_method?.payment_method
          ) > -1
        ) {
          const params = {
            ..._order,
            device_id: "",
            // device_id: "20CFA8BA-4248-43AC-8D13-7881E810CE53",
            order_temp: rs.data.id,
            order_id: rs.data.id,
            kde_order_id: rs.data.order_id,
            source: "WEB",
          };
          const result: any = await payments.payooPayment(params);
          if (result.status == 200) {
            clearShoppingCart();
            window.location.href = result.data.order.payment_url;
          }
        } else if (rs.data.expire_at && rs.data.id) {
          cb(rs.data);
        } else {
          clearShoppingCart();
          cb(rs.data);
        }
      }
    } catch (error) {
      clearShoppingCart();
      cb(null, error);
    }
  }
};

export default {
  addCartItem: addCartItem,
  getShoppingCart: getShoppingCart,
  updateShoppingCartItems: updateShoppingCartItems,
  checkVoucherCode: checkVoucherCode,
  updateVoucherCode: updateVoucherCode,
  updateReferralCode: updateReferralCode,
  submitOrder: submitOrder,
};
